// extracted by mini-css-extract-plugin
export default {"statusIndicator":"statusIndicatort8v1E"};